/**
 * Termos que NUNCA se traduzem.
 *
 * Os catálogos (`src/locales/*.json`) referem-se a estes termos por
 * placeholder (`{{apav}}`, `{{number}}`, …) para que o eTranslation — ou
 * qualquer outro motor — não lhes toque. Aqui é que os placeholders recebem
 * o valor final, igual em todas as línguas. Entram no i18next por
 * `interpolation.defaultVariables` (ver src/i18n.js), por isso resolvem em
 * qualquer `t()` sem ser preciso passá-los à mão.
 *
 * Lição das rondas anteriores: os números levam isolamento LTR
 * (U+2066…U+2069, invisíveis) senão o algoritmo bidi mostra «116 006» como
 * «006 116» em árabe e urdu. As versões cruas são para os href `tel:`, que
 * partiriam com esses caracteres.
 */
export const NO_TRANSLATE = {
  // 1. APAV e marca
  apav: 'APAV',
  apavPt: 'APAV.PT',
  apavSafe: 'APAV SAFE',
  aoLado: 'Ao Lado das Vítimas',

  // 2. Números que salvam vidas — a MT já os apagou e já os LOCALIZOU noutros
  //    sites da frota (o 112 saiu «911» em quatro línguas).
  number: '⁦116 006⁩',
  emergency: '⁦112⁩',
  safeNumber: '⁦21 358 79 14⁩',
  telNumber: '116006',
  telEmergency: '112',
  telSafe: '213587914',

  // 3. Forças de segurança e organismos do Estado (a MT translitera-os)
  psp: 'PSP',
  gnr: 'GNR',
  sef: 'SEF',
  aima: 'AIMA',
  act: 'ACT',
  otsh: 'OTSH',
  cig: 'CIG',
  sns: 'SNS',

  // 4. Organizações da Rede de Apoio e Proteção a Vítimas de Tráfico
  rapvt: 'RAPVT',
  akto: 'AKTO',
  apf: 'APF',
  cpr: 'CPR',
  jrs: 'JRS',
  oim: 'OIM',

  // 5. Linhas e serviços da APAV
  lav: 'Linha de Apoio à Vítima',
  infovitimas: 'InfoVítimas',

  // 6. Contactos
  mailSafe: 'safe@apav.pt',

  // 7. Marcas e redes sociais
  youtube: 'YouTube',
  bluesky: 'Bluesky',

  // 8. Nomes portugueses das instituições. Nas línguas traduzidas o nome vai
  //    traduzido com este a seguir: «الشرطة القضائية {{pj}}». Quem lê percebe
  //    o que é E sabe o nome que vai encontrar à porta, no site e no papel. Em
  //    português não se repetem — o catálogo pt escreve-os por extenso.
  //
  //    Os parênteses vivem AQUI, dentro do isolamento LTR, e não no catálogo:
  //    um nome latino longo dentro de um parágrafo árabe parte-se entre linhas
  //    e cada linha reordena por si, e o cartão da CIG mostrava «(Comissão
  //    para a Cidadania e a) Igualdade de Género». Isolado, o nome inteiro
  //    quebra como um bloco.
  pj: '⁦(Polícia Judiciária)⁩',
  mp: '⁦(Ministério Público)⁩',
  savLisboa: '⁦(Serviços de Apoio à Vítima de Lisboa)⁩',
  rapvtNome: '⁦(Rede de Apoio e Proteção a Vítimas de Tráfico)⁩',
  actNome: '⁦(Autoridade para as Condições do Trabalho)⁩',
  aimaNome: '⁦(Agência para a Integração, Migrações e Asilo)⁩',
  aktoNome: '⁦(Direitos Humanos e Democracia)⁩',
  apfNome: '⁦(Associação para o Planeamento da Família)⁩',
  spNome: '⁦(Centro de Acolhimento e Proteção para Vítimas de Tráfico de Seres Humanos do Sexo Masculino)⁩',
  cigNome: '⁦(Comissão para a Cidadania e a Igualdade de Género)⁩',
  cprNome: '⁦(Conselho Português para os Refugiados)⁩',
  jrsNome: '⁦(Serviço Jesuíta aos Refugiados em Portugal)⁩',
  oimNome: '⁦(Organização Internacional para as Migrações)⁩',
  otshNome: '⁦(Observatório do Tráfico de Seres Humanos)⁩',
};

/**
 * Dos termos acima, estes TÊM de atravessar a tradução intactos: o submissor
 * manda-os resolvidos, o recolhedor volta a pô-los como placeholder e o
 * verificador falha o commit se algum se perder.
 *
 * Ficam de fora {{lav}} e {{infovitimas}} em frase corrida — são nomes de
 * serviço, e é melhor que sejam traduzidos. A sigla APAV sobrevive na mesma.
 */
export const INVARIANTES = [
  'apav', 'apavPt', 'apavSafe',
  'number', 'emergency', 'safeNumber', 'telNumber', 'telEmergency', 'telSafe',
  'psp', 'gnr', 'sef', 'aima', 'act', 'otsh', 'cig', 'sns',
  'rapvt', 'akto', 'apf', 'cpr', 'jrs', 'oim',
  'mailSafe', 'youtube', 'bluesky',
];

export default NO_TRANSLATE;
